import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
const initialState = [];
export const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        enqueueAlert: (state, action) => {
            state.push(Object.assign({ key: uuidv4() }, action.payload));
        },
        removeAlert: (state, action) => {
            state = state.filter((alert) => alert.key !== action.payload);
        },
        clearAlerts: (state) => {
            state = [];
        },
    },
});
export const { enqueueAlert, removeAlert } = alertSlice.actions;
export default alertSlice.reducer;
